/** Options for working-paper persist (manual Save vs idle auto-save). */
export interface WpPersistOptions {
  /** Close dialog after successful save. Default false (keep WP open so in-dialog save feedback is visible). */
  closeOnSuccess?: boolean;
  /** Suppress snackbars / hard validation toasts. Default false. */
  silent?: boolean;
}

export function resolveWpPersistOptions(opts?: WpPersistOptions): Required<WpPersistOptions> {
  return {
    closeOnSuccess: opts?.closeOnSuccess === true,
    silent: opts?.silent === true,
  };
}
